/**
 * 新規登録（回収）
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/requests/directly_completes`

const orders_requests_directly_complete = {
  namespaced: true,
  actions: {
    /**
     * 受注　登録完了
     * @param commit
     * @param id
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { id }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${id}`
        Vue.$http.put(api_path).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },

  },
}
export default orders_requests_directly_complete
